import { useEffect, useState } from 'react';
import IconChecked from '../icons/checked';
import IconMinus from '../icons/collapse';
import { CheckboxProps } from './types';

import './checkbox.css';

export default function CheckboxInput({
  type,
  title,
  disabled,
  onChange,
  value,
  checked = false,
  name,
  labelClassName = '',
  visualClassName = '',
  tabIndex,
  partialChecked,
  description,
  partialDisabled,
}: CheckboxProps): React.JSX.Element {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <label
      htmlFor={`checkbox-${name}${
        type === 'radio' ? `-${value as string}` : ''
      }`}
      className={`input-button-wrapper ${
        type === 'radio' ? 'radio' : 'checkbox'
      } ${labelClassName}`}
      tabIndex={-1}
    >
      <input
        type={type}
        name={name}
        className="input-button"
        id={`checkbox-${name}`}
        disabled={disabled || partialDisabled}
        onChange={(e) => onChange && onChange(e)}
        checked={isChecked || Boolean(partialChecked)}
        value={value}
        autoComplete="off"
        tabIndex={tabIndex}
      />
      <div
        className={`visual ${visualClassName} ${
          description ? 'visual-flex' : ''
        } ${partialDisabled ? 'partial-disabled' : ''}`}
      >
        {title}
        {description && (
          <div className="checkbox-description">{description}</div>
        )}
        {(isChecked || partialChecked) && type === 'checkbox' && (
          <>
            {partialChecked && (
              <IconMinus
                className={`${
                  disabled ? 'disabled' : ''
                } icon-checked icon-partial-checked`}
              />
            )}

            {!partialChecked && (
              <IconChecked className={disabled ? 'disabled' : ''} />
            )}
          </>
        )}
      </div>
    </label>
  );
}
